import { useState, forwardRef, useRef, useImperativeHandle } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import styled from "styled-components";
import MuiBlock from '../atom/MuiCustoms';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import LuckyNumberList from "./LuckyNumberList";
import Breakpoints from "../config/Breakpoints";
import LuckyNumberStatement from "./LuckyNumberStatement";

const CustomDialog = styled(Dialog)`
    .MuiDialog-container > .MuiPaper-root {
        width: 100%;
        max-width: 48rem;
        overflow: hidden;
    }

    .MuiDialogTitle-root {
        display: flex;
        gap: 1rem;
        align-items: center;
        text-align: center;
        text-transform: uppercase;
        font-size: var(--font-size-xs);
        font-weight: var(--font-weight-bold);
        letter-spacing: .05em;

        & > span {
            flex: 1;

            @media ${Breakpoints.sm} {
                br {
                    display: none;
                }
            }
        }

        .MuiButtonBase-root {
            color: var(--color-gray) !important;
        }
    }
`;

const LuckyNumberListModal = forwardRef(({promoData, style}, ref) => {
    const innerRef = useRef();
    const [open, setOpened] = useState(false);
    const [mode, setMode] = useState('numberList');

    const handleClose = () => {
        setOpened(false);
    };

    const changeModeToExtract = () => {
        setMode('extract');
    }

    const changeModeToNumberList = () => {
        setMode('numberList');
    }

    useImperativeHandle(ref, () => ({
        openDialog: () => setOpened(true),
        closeDialog: () => setOpened(false)
    }));

    return (
        <MuiBlock style={style}>
            <CustomDialog
                ref={innerRef}
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <IconButton onClick={changeModeToNumberList} title="Voltar" aria-label="Voltar" color="secondary" style={{visibility: mode === 'numberList' ? 'hidden' : 'visible'}}><ArrowBackOutlinedIcon /></IconButton>
                    <span>
                        {mode === 'numberList' && <>Números da sorte</>}
                        {mode !== 'numberList' && <>Como ganhou<br/> números da sorte</>}
                    </span>
                    <IconButton onClick={() => handleClose()} title="Fechar" aria-label="Fechar" color="secondary"><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent>
                    {mode === 'numberList' && <LuckyNumberList promoData={promoData} changeMode={changeModeToExtract} />}
                    {mode === 'extract' && <LuckyNumberStatement promoData={promoData} />}
                </DialogContent>
            </CustomDialog>
        </MuiBlock>
    )
});



export default LuckyNumberListModal;